export const isMobile = (agent) => /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(agent);

export const isSafari = () => {
	return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
};

export const isMobileView = () => document.documentElement.clientWidth < 767;

export const isTouchDevice = () => ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0);

export const isVirtualKeyboardAPI = 'virtualKeyboard' in navigator;

export const TINY_SCREEN_WIDTH_MQL = window.matchMedia('(max-width: 375px)');
